import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

const SPINNER = '<div class="text-center py-4"><div class="spinner-border text-primary" role="status"></div></div>'
const errorAlert = (text) => `<div class="alert alert-danger mb-0">${text}</div>`

// Shared modal with the media library: loads the picker fragment, uploads files and puts the chosen
// image into the field that opened it (HTML snippet at the cursor, or the URL for URL fields).
export default class extends Controller {
  static targets = ["body"]
  static values = { url: String }

  disconnect() {
    this.abortRequest()
  }

  open({ detail: { field, mode } }) {
    this.field = field
    this.mode = mode || "snippet"
    Modal.getOrCreateInstance(this.element).show()
    this.load(this.urlValue)
  }

  choose(event) {
    const field = this.field
    if (!field) return

    const tile = event.currentTarget
    if (this.mode === "url") {
      field.value = tile.dataset.url
    } else {
      const start = field.selectionStart ?? field.value.length
      const end = field.selectionEnd ?? start
      const before = field.value.slice(0, start)
      const text = `${before && !before.endsWith("\n") ? "\n" : ""}${tile.dataset.snippet}\n`
      field.setRangeText(text, start, end, "end")
    }
    field.dispatchEvent(new Event("input", { bubbles: true }))

    this.element.addEventListener("hidden.bs.modal", () => field.focus(), { once: true })
    Modal.getOrCreateInstance(this.element).hide()
  }

  paginate(event) {
    const link = event.target.closest("a[href]")
    if (!link) return

    event.preventDefault()
    // Disabled items (the «…» gap, the current page) are not navigable.
    if (link.closest(".disabled") || link.getAttribute("href") === "#") return
    this.load(link.href)
  }

  upload(event) {
    event.preventDefault()
    const form = event.target
    this.request(form.action, { method: "POST", body: new FormData(form) })
  }

  load(url) {
    this.request(url, { method: "GET" })
  }

  // A newer request (another page, an upload) replaces the older one: only the last response is shown.
  abortRequest() {
    this.controller?.abort()
    this.controller = null
  }

  async request(url, options) {
    this.abortRequest()
    this.controller = new AbortController()
    const { signal } = this.controller
    this.bodyTarget.innerHTML = SPINNER
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(url, { ...options, signal, headers: { "X-CSRF-Token": token, "Accept": "text/html" } })
      if (response.redirected) {
        // Expired admin session: Devise redirected to the login page.
        this.bodyTarget.innerHTML = errorAlert("Сессия истекла — войдите снова")
      } else if (response.ok || response.status === 422) {
        // 422 still carries the picker, with the upload error inside.
        this.bodyTarget.innerHTML = await response.text()
      } else {
        this.bodyTarget.innerHTML = errorAlert("Не удалось загрузить медиатеку")
      }
    } catch (error) {
      if (error.name === "AbortError") return
      this.bodyTarget.innerHTML = errorAlert("Нет связи с сервером")
    }
  }
}
